import { render, staticRenderFns } from "./ScriptEdit.vue?vue&type=template&id=87554766&scoped=true&"
import script from "./ScriptEdit.vue?vue&type=script&lang=js&"
export * from "./ScriptEdit.vue?vue&type=script&lang=js&"
import style0 from "./ScriptEdit.vue?vue&type=style&index=0&id=87554766&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87554766",
  null
  
)

export default component.exports